// Chat.js - Enhanced UI
import React from "react";
import ChatArea from "../ChatArea/ChatArea";
import ChatNav from "../ChatNav/ChatNav";
import "./Chat.css";
import { Box, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    height: '100%',
    minHeight: '89vh',
    maxHeight: '89vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff'
  },
  chatPaper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 0,
    backgroundColor: '#ffffff'
  },
  chatNav: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    padding: theme.spacing(2),
    boxShadow: '0 2px 8px rgba(89, 63, 184, 0.1)',
    flexShrink: 0,
    minHeight: '85px'
  },
  chatArea: {
    flex: 1,
    overflow: 'auto',
    background: '#ffffff',
    display: 'flex',
    flexDirection: 'column'
  }
}));

const ChatBox = () => {
  const classes = useStyles();

  return (
    <Box className={classes.chatContainer}>
      <Paper elevation={2} className={classes.chatPaper}>
        <Box className={classes.chatNav}>
          <ChatNav />
        </Box>
        <Box className={classes.chatArea}>
          <ChatArea />
        </Box>
      </Paper>
    </Box>
  );
};

export default ChatBox;